import React, { Dispatch, SetStateAction } from 'react';

import { MdOutlineEventNote } from 'react-icons/md';

import TextSelect from 'components/layout/form/TextSelect';
import { filterProvider } from '../../providers';

import { Container } from './styles';

type PeriodFilterProps = {
  dataValue: number;
  setDataValue: Dispatch<SetStateAction<number>>;
};

const PeriodFilter: React.FC<PeriodFilterProps> = ({
  dataValue,
  setDataValue,
}) => {
  return (
    <Container>
      <TextSelect
        placeholder="Período"
        type="text"
        value={dataValue}
        onChange={(event) => {
          setDataValue(Number(event?.currentTarget?.value));
        }}
        LeadingIcon={<MdOutlineEventNote />}
      >
        {filterProvider.map((filter) => (
          <option key={filter.value} value={filter.value}>
            {filter.label}
          </option>
        ))}
      </TextSelect>
    </Container>
  );
};

export default PeriodFilter;
